import { useContext } from "react";
import { AlertContext } from "../context/AlertContext";
import { motion } from "framer-motion";
import { fadeIn } from "../utils/motion";
import { SVGS } from ".";
const AlertComponent = () => {
  const { alert, clearAlert } = useContext(AlertContext);

  if (!alert.message) return null;

  const getClassNames = (type) => {
    switch (type) {
      case "error":
        return "mt-2 bg-red-100 border border-red-200 text-sm text-red-800 rounded-lg p-4  /10     flex justify-between";
      case "warning":
        return "mt-2 bg-yellow-100 border border-yellow-200 text-sm text-yellow-800 rounded-lg p-4  /10     flex justify-between";
      case "info":
        return "mt-2 bg-blue-100 border border-blue-200 text-sm text-blue-800 rounded-lg p-4  /10     flex justify-between";
      default:
        return "mt-2 bg-gray-100 border border-gray-200 text-sm text-gray-800 rounded-lg p-4  /10     flex justify-between";
    }
  };

  const getName = (type) => {
    switch (type) {
      case "error":
        return "Greska:";
      case "warning":
        return "Upozorenje:";
      case "info":
        return "Info:";
      default:
        return "";
    }
  };

  return (
    <div className="fixed top-32 md:top-32 lg:top-20 left-0 right-0 z-50 w-full flex justify-center px-6 py-2">
      <motion.div
        variants={fadeIn("up", "tween", 0, 0.5)}
        initial="hidden"
        animate="show"
        role="alert"
        className="w-full md:w-1/2 lg:w-1/3 "
      >
        <div className={getClassNames(alert.type)} role="alert">
          <span>
            <span className="font-bold mr-1">{getName(alert.type)}</span>{" "}
            {alert.message}
          </span>
          <button
            onClick={() => clearAlert()}
            className="ml-4 text-md text-current font-bold"
          >
            <span className="sr-only">Dismiss</span>
            <SVGS.DissmissSVG />
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default AlertComponent;
